/*a component that is used to display a header for a form editor. */
import React from "react"
import DynamicFormTypes from "../../Types/DynamicFormsTypes"
import DynamicFormPaletteTypes from "src/store/DyanmicFormPalette/types"
import DynamicFormEditBaseDetails from "../DynamicFormEditBaseDetails/DynamicFormEditBaseDetails"
import referenceHelper from "../../Utils/ReferenceHelper"
import paletteEngine from "../../Utils/paletteEngine"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import Marquee from "react-fast-marquee"
import "./DynamicFormEditorHeader.css"

interface Props {
    manageParentState: Function
    manageGrandparentState: Function
    callGrandParentFunction: Function
    formTypes: Array<{ CustomFormTypeId: number, Type: string }> | []
    editorState: {
        form: DynamicFormTypes
        forceMobile: boolean
        editBaseDetails: boolean
    }
    hints: boolean
    saveForm: Function
    palette: Array<DynamicFormPaletteTypes>
}


/* A React component that is used to display a header for a form editor. */
function DynamicFormEditorHeader(props: Props) {

    const marqueeTitle = (props.editorState.form.Name && props.editorState.form.Name.length > 20) ? true : false

    const DynamicFormEditorHeaderToolTip = (text: string, overrideHints?: boolean) => (
        <Tooltip id={`dynamic-form-tool-tip-hide-${!props.hints && !overrideHints}`}>
            {text}
        </Tooltip>
    )

    return (
        <div className="DynamicFormEditorHeader" style={{ boxShadow: `2px 2px 2px ${paletteEngine.getPaletteColor("formBackgroundColor")}` }}>
            <div className="DynamicFormEditorHeaderSection DynamicFormEditorHeaderSectionLeft">
                <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip(`${props.editorState.form.Name} (${referenceHelper.getFormTypeRefDataById(props.editorState.form.CustomFormTypeId, props.formTypes).Type})`, true)}>
                    <div id="" className={`DynamicFormEditorHeaderItem ${marqueeTitle ? "DynamicFormEditorHeaderItemMarquee" : "DynamicFormEditorHeaderItemNoMarquee"}`}>
                        <Marquee gradient={false} play={marqueeTitle} pauseOnHover={true}>
                            <p id="dynamic-form-editor-header-item-form-title">{`${props.editorState.form.Name} (${referenceHelper.getFormTypeRefDataById(props.editorState.form.CustomFormTypeId, props.formTypes).Type})`}</p>
                        </Marquee>
                    </div>
                </OverlayTrigger>
            </div>
            <div className="DynamicFormEditorHeaderSection DynamicFormEditorHeaderSectionMiddle">
                <div className="DynamicFormEditorHeaderSectionMiddlePreviewType">
                    <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip("Toggle device type")}>
                        <div className={`DynamicFormEditorHeaderSectionMiddlePreviewTypeItem ${!props.editorState.forceMobile ? "DynamicFormEditorHeaderSectionMiddlePreviewTypeItemActive" : ""}`}
                            onClick={() => props.manageParentState([{ key: "forceMobile" }])}
                        >
                            <span className="material-icons">computer</span>
                        </div>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip("Toggle device type")}>
                        <div className={`DynamicFormEditorHeaderSectionMiddlePreviewTypeItem ${props.editorState.forceMobile ? "DynamicFormEditorHeaderSectionMiddlePreviewTypeItemActive" : ""}`}
                            onClick={() => props.manageParentState([{ key: "forceMobile" }])}
                        >
                            <span className="material-icons">phone_android</span>
                        </div>
                    </OverlayTrigger>
                    <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip("Edit Palette")}>
                        <div className="DynamicFormEditorHeaderSectionMiddlePreviewTypeItem DynamicFormEditorHeaderSectionMiddlePreviewTypeItemPalette">
                            <span className="material-icons" onClick={() => props.manageParentState([{ key: "editPalette" }])}>palette</span>
                        </div>
                    </OverlayTrigger>
                </div>
            </div>
            <div className="DynamicFormEditorHeaderSection DynamicFormEditorHeaderSectionRight">
                <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip("Form preview")}>
                    <div id="dynamic-form-editor-header-preview" className="DynamicFormEditorHeaderItem DynamicFormEditorHeaderFormActionBtn DynamicFormEditorHeaderFormActionBtnFirst"
                        onClick={() => props.manageParentState([{ key: "preview" }])}
                    >
                        <p>Preview</p>
                    </div>
                </OverlayTrigger>
                <div id="dynamic-form-editor-header-edit" className="DynamicFormEditorHeaderItem DynamicFormEditorHeaderFormActionBtn"
                    onClick={() => props.manageParentState([{ key: "editBaseDetails", value: props.editorState.form }])}
                >
                    <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip("Edit name/type")}>
                        <span className="material-icons">edit</span>
                    </OverlayTrigger>
                </div>
                <div id="dynamic-form-editor-header-save" className="DynamicFormEditorHeaderItem DynamicFormEditorHeaderFormActionBtn"
                    onClick={() => props.saveForm()}>
                    <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip("Save")}
                    >
                        <span className="material-icons">save</span>
                    </OverlayTrigger>
                </div>
                <div id="dynamic-form-editor-header-close" className="DynamicFormEditorHeaderItem DynamicFormEditorHeaderFormActionBtn DynamicFormEditorHeaderFormActionBtnLast"
                    onClick={() => {
                        props.manageGrandparentState([{ key: "formToEdit", value: null }])
                        props.callGrandParentFunction("resetList")
                    }}
                >
                    <OverlayTrigger placement="bottom" overlay={DynamicFormEditorHeaderToolTip("Exit")}>
                        <span className="material-icons">close</span>
                    </OverlayTrigger>
                </div>
            </div>
            {props.editorState.editBaseDetails &&
                <DynamicFormEditBaseDetails
                    form={props.editorState.form}
                    formTypes={props.formTypes}
                    manageParentState={props.manageParentState}
                />}
        </div>
    )
}

export default DynamicFormEditorHeader